import styled from 'styled-components'

export const DateWrapper = styled.p`
  font-size: 28px;
  margin-bottom: 10px;
`

export const TimeWrapper = styled.p`
  font-size: 44px;
  margin-top: 10px;
`
